namespace Portico.Directives {

	import Inject = Portico.Decorators.Inject;
	import services = Portico.Services;

	export interface ITcFormController {
		disabled: boolean;
		focus: string;
		isAllowed: () => boolean;
		name: string;
        ngForm: angular.IFormController;
        tcInputs: ITcInputController[];

		isDisabled(): boolean;
		unSubmit(): void;
    }

	@Inject('$timeout')
    export class TcFormController implements ITcFormController {
		disabled: boolean;
		focus: string;
		isAllowed: () => boolean;
		name: string;
        ngForm: angular.IFormController;
        tcInputs: ITcInputController[] = [];

		constructor(private $timeout: angular.ITimeoutService) {
		}

		isDisabled(): boolean {
			if (this.disabled) {
				return true;
			}

			if (this.isAllowed && !this.isAllowed()) {
				return true;
			}

			return false;
		}

		unSubmit(): void {
			this.$timeout(() => {
				this.ngForm.$setUntouched();
				this.ngForm.$setPristine();
			});
		}
    }

	angular.module('app').directive('tcForm', ['$timeout', ($timeout: angular.ITimeoutService) => {
		return {
			bindToController: {
				disabled: '@',
				focus: '@',
				isAllowed: '&?',
				name: '@'
			},
			controller: <any>TcFormController,
			controllerAs: '$form',
			link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
				const tcForm: ITcFormController = $ctrl[0];
				const focus = !tcForm.focus || tcForm.focus === 'true' ? true : false;

				if (!tcForm.name) {
					tcForm.name = '$form.ngForm';
				}

				if (focus) {
					$timeout(() => {
						$element.find("button, input").first().focus();
					}, 50);
				}
			},
			restrict: 'E',
			require: ['tcForm'],
			scope: true,
			template:
				`<form novalidate name="{{$form.name}}" ng-model-options="{ updateOn: 'default blur', debounce: { default: 50, blur: 0 } }">
					<div ng-transclude>
					</div>
				</form>`,
			transclude: true
		};
    }]);
}